import { Button, CircularProgress } from "@mui/material";
import React from "react";

const LoaderButton = ({ isSubmitting, hide = false }) => {
  return (
    <>
      <Button
        variant="contained"
        type="submit"
        startIcon={
          isSubmitting ? (
            <CircularProgress size="1rem" sx={{ color: "red" }} />
          ) : undefined
        }
        sx={{ display: hide ? "none" : "block" }}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Please Wait" : "Save"}
      </Button>
    </>
  );
};

export default LoaderButton;
